import { useMutation } from "@tanstack/react-query";
import { UserNoteService } from "../../services/user-note.service";
import { IUserNote, IUserNoteModel } from "../../models/UserNote";

export const useUserNoteMutations = (userId: string) => {
  const { mutate: createNote, isPending: isCreating } = useMutation<
    IUserNote,
    Error,
    IUserNoteModel
  >({
    mutationFn: async (model) => UserNoteService.create(userId, model).then((res) => res.data),
  });

  const { mutate: updateNote, isPending: isUpdating } = useMutation<
    IUserNote,
    Error,
    { id: string; model: IUserNoteModel }
  >({
    mutationFn: async ({ id, model }) =>
      UserNoteService.update(userId, id, model).then((res) => res.data),
  });

  const { mutate: deleteNote } = useMutation<{}, Error, string>({
    mutationFn: async (id) => UserNoteService.delete(userId, id).then((res) => res.data),
  });

  return {
    createNote,
    updateNote,
    deleteNote,
    isSaving: isCreating || isUpdating,
  };
};
